// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = window.MSRSearch.theme_assets; // Fixes public path chunking.

// Preact
// eslint-disable-next-line no-unused-vars
import { Fragment, h, render } from "preact";
import queryString from "query-string";
import CurrentSelections from "./components/CurrentSelections";
import Form from "./components/Form";
import Header from "./components/Header";
import Overlay from "./components/Overlay";
import Results from "./components/Results";
// Components
import SearchProvider from "./providers/Search";
import { emitEvent } from "./util";

let initialParams = {};

/**
 *
 * @returns
 */
const App = ({ sectionName }) => {
	return (
		<SearchProvider initialParams={initialParams} sectionName={sectionName}>
			<div className="faceted-search__sidebar">
				<aside>
					<CurrentSelections />
					<Form />
				</aside>
			</div>
			<div className="faceted-search__results faceted-search-results">
				<Header />
				<Results />
			</div>
			<Overlay />
		</SearchProvider>
	);
};

/**
 *
 * @returns
 */
const init = () => {
	if ("undefined" !== typeof window) {
		const facetedSearch = document.getElementById("faceted-search");
		const facetedSearchForm = document.getElementById(
			"faceted-search-form",
		);

		// Bail early
		if (!facetedSearch || !facetedSearchForm || !window.MSRSearch) {
			return;
		}

		const sectionName = facetedSearch.getAttribute("data-section-name");

		// Get search query params
		initialParams = queryString.parse(window.location.search, {
			arrayFormat: "bracket",
		});

		// Clear the page.
		facetedSearch.innerHTML = "";
		facetedSearch.setAttribute("data-state", "ready");

		// Render.
		render(<App sectionName={sectionName} />, facetedSearch);

		document.addEventListener("preact:contentchange", () => {
			emitEvent("toggle:restart");
		});
	}
};

init();
